import { styles } from "./PageCustomers.style";
import { values } from "lodash";

import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { push } from "connected-react-router";

import { Typography, WithStyles, withStyles, Grid } from "@material-ui/core";

import { RootState } from "../../types/RootState";
import { Customer } from "../../types/Customer";

import CustomerTable from "../../components/CustomerTable/CustomerTable";
import InputCustomerAutocomplete from "../../components/InputCustomerAutocomplete/InputCustomerAutocomplete";
import { PageConnected } from "../Page/Page";

type PageCustomersProps = {
    customers: { [customerId: string]: Customer };
    push(path: string);
};

class PageCustomers extends React.Component<PageCustomersProps & WithStyles<typeof styles>> {

    public render() {

        const { classes, customers } = this.props;

        return (
            <PageConnected>
                <Grid container={true} spacing={16} className={classes.container}>
                    <Grid item={true} sm={8}>
                        <Typography className={classes.title} variant="display1">Clients</Typography>
                    </Grid>
                    <Grid item={true} sm={4} style={{ paddingBottom: 0 }}>
                        <InputCustomerAutocomplete autocompleteCustomers={values(customers)} onChange={customer => this.onInputCustomerAutocompleteChange(customer)} placeholder="Rechercher un client…" />
                    </Grid>
                </Grid>
                <div className={classes.table}>
                    <CustomerTable customers={customers} push={this.props.push}/>
                </div>
            </PageConnected>
        );
    }

    /**
     *
     * @param customer
     * @param element
     */
    private onInputCustomerAutocompleteChange(customer: Customer) {
        this.props.push(`/customer/${customer.id}`);
    }

}

export const PageCustomersConnected = compose(
    withStyles(styles),
    connect(
        (state: RootState, ownProps: PageCustomersProps) => ({
            ...ownProps,
            customers: state.me.userData ? state.me.userData.customers : {}
        }),
        { push }
    )
)(PageCustomers);

// For stories
export const PageCustomersStyled = withStyles(styles)(PageCustomers);



// WEBPACK FOOTER //
// ./src/pages/PageCustomers/PageCustomers.tsx